/*
 * Copyright 2025 MadeByTatwa LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Copyright 2025 MadeByTatwa LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Detector module exports and registry
 */
import { NodeWebDetector } from './node-web.js';
import { NodeApiDetector } from './node-api.js';
import { PythonDetector } from './python.js';
import { FlutterDetector } from './flutter.js';
import { DockerDetector } from './docker.js';
import { MonorepoDetector } from './monorepo.js';
import type { Detector } from './base.js';

/**
 * All available detectors (Phases 1-4)
 */
export const detectors: Detector[] = [
  // Phase 1: Node.js
  new NodeWebDetector(),
  new NodeApiDetector(),
  // Phase 3: Cross-language
  new PythonDetector(),
  new FlutterDetector(),
  // Phase 4: Docker & Monorepos
  new DockerDetector(),
  new MonorepoDetector(),
];

export * from './base.js';
export * from './node-web.js';
export * from './node-api.js';
export * from './python.js';
export * from './flutter.js';
export * from './docker.js';
export * from './monorepo.js';

